import { connect } from 'react-redux';
import { Map } from 'immutable';

// components
import ListItem from './ListItem';

const mapStateToProps = (state) => ({
  categories: state.getIn(['category', 'data', 'items']) || Map(),
});

export default connect(mapStateToProps)(ListItem);
